import { makeIntranet } from 'src/main/factories/pages'

export default makeIntranet
